import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import scrollbarStyle from "./Scrollbar.style";
import { getViewProps } from "./utils";
/* eslint-disable react/prop-types */

const Track = ({
  style
}) => ___EmotionJSX("div", {
  style: style,
  css: scrollbarStyle.track
});

const Thumb = ({
  style
}) => ___EmotionJSX("div", {
  style: style,
  css: scrollbarStyle.thumb
});

const ViewComponent = ({
  defaultProps,
  givenProps
}) => ___EmotionJSX("div", _extends({}, getViewProps(defaultProps, givenProps), {
  className: "scroll-view"
}));

const View = givenProps => defaultProps => ViewComponent({
  defaultProps,
  givenProps
});

const Scrollbar = (_ref) => {
  let {
    children,
    className,
    viewProps,
    scrollBarRef
  } = _ref,
      scrollbarProps = _objectWithoutProperties(_ref, ["children", "className", "viewProps", "scrollBarRef"]);

  return ___EmotionJSX(Scrollbars, _extends({
    autoHide: true,
    ref: scrollBarRef,
    className: className,
    renderTrackVertical: Track,
    renderThumbVertical: Thumb,
    renderView: View(viewProps)
  }, scrollbarProps), children);
};

Scrollbar.propTypes = {
  className: PropTypes.string,
  thumbSize: PropTypes.number,
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  viewProps: PropTypes.object,
  scrollBarRef: PropTypes.func
};
Scrollbar.defaultProps = {
  className: '',
  thumbSize: null,
  children: null,
  viewProps: {},
  scrollBarRef: () => {}
};
export default Scrollbar;